import { SimplePageLayout, SimplePageContentWrapper } from '@flexinet/ui-components';
import { MessagesPageHeader } from '../components/PageHeaders';
import { MessagesPageNavigation } from '../navigation/PageNavigations';
import { MessagesTable } from '../tables/MessagesTable';

export const MessagesStatisticsPage = () => {
    return (
        <SimplePageLayout
            pageHeader={<MessagesPageHeader />}
            pageNavigation={<MessagesPageNavigation />}
        >
            <SimplePageContentWrapper>
                <MessagesTable />
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
